export default "__VITE_ASSET__Cxr8MZCo__"